import axios from "axios";
import apiUrl from "./apiConfig";

// 11/22/21 Not sure what this is or if it's necessary, but I'm keeping it because it was in TBIRequests
axios.defaults.withCredentials = true;

export const sendMessage = (data) => {
  return axios.post(`${apiUrl}/sendMessage`, data);
};

export const getMessages = (patientId) => {
  return axios.get(`${apiUrl}/getMessages`, {
    params: { patientId },
  });
};

export const getUnreadProviderMessages = () => {
  return axios.get(`${apiUrl}/get-unread-provider-messages`);
};

export const updateMessageRead = ({ messageId }) => {
  return axios.put(
    `${apiUrl}/updateMessageRead`,
    {},
    {
      params: { messageId },
    }
  );
};

export const deleteMessage = ({ messageId }) => {
  return axios.delete(`${apiUrl}/deleteMessage`, { params: { messageId } });
};

export const getProviderList = () => {
  return axios.get(`${apiUrl}/getProviderList`);
};

// upload URL endpoints

export const getVideoUploadUrl = (file) => {
  return axios.post(`${apiUrl}/video-upload-url`, null, {
    headers: {
      "Tus-Resumable": "1.0.0",
      "Upload-Length": file.size,
      "Upload-Metadata": `name ${btoa(file.name)},maxDurationSeconds ${btoa("90")}`,
    },
  });
};

export const getImageUploadUrl = () => {
  return axios.post(`${apiUrl}/image-upload-url`);
};

export const patchImageMetadata = (data) => {
  return axios.patch(`${apiUrl}/patch-image-metadata`, data);
}

export const deleteImage = (imageId) => {
  return axios.delete(`${apiUrl}/delete-image/${imageId}`);
}
   

export const deleteVideo = (videoId) => {
  return axios.delete(`${apiUrl}/delete-video/${videoId}`);
}